import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class HiddenQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.HIDDEN;
  type: string;
  name: string;
  id: string;
  value: any;

  constructor(options: any = {}) {
    super(options);
    this.type = options['type'] || '';
    this.name = options['label'] || '';
    this.id = options['key'] || '';
    this.value = options['displayValue'] || void 0;
  }
}
